import { css } from '@emotion/react';
import { SPACER } from 'radiance-ui/lib/constants';
import type { ThemeType } from 'radiance-ui/lib/constants';

export const sunscreenGiveawayBannerStyles = (theme: ThemeType) => css`
  font-size: 0.875rem;
  background: #ff824f;
  padding: ${SPACER.small} ${SPACER.xlarge};
  text-transform: initial;
  text-align: center;
  letter-spacing: initial;
  font-weight: bold;
  color: ${theme.COLORS.primary};
`;
